import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedBankProduct: {
    bankProduct: {
      _id: undefined,
    },
    files: [],
  },
  bankProductAdded: false,
  bankProductUpdated: false,
  bankProductRemoved: false,
};

const bankProductsSlice = createSlice({
  name: "bankProducts",
  initialState,
  reducers: {
    getBankProducts(state, action) {
      state.list = action.payload.bankProducts;
      state.meta = action.payload.meta;
    },
    getBankProductsById(state, action) {
      state.selectedBankProduct = action.payload;
    },
    addBankProducts(state, action) {
      state.bankProductAdded = true;
    },
    updateBankProducts(state, action) {
      state.bankProductUpdated = true;
    },
    removeBankProducts(state, action) {
      state.bankProductRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const bankProductsActions = bankProductsSlice.actions;
export default bankProductsSlice;
